import React from 'react';
import { Provider } from 'react-redux';
import { unstable_batchedUpdates } from 'react-dom';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './index.scss';
import './i18n';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store/Store';

const root = ReactDOM.createRoot(
   document.getElementById('root') as HTMLElement
);

unstable_batchedUpdates(() => {
   console.error = () => {};
});

interface ErrorBoundaryProps {
   children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
   componentDidCatch(error: Error) {
      if (error.message.includes('ToastContainer')) {
         return;
      }
   }

   render() {
      return this.props.children;
   }
}

const queryClient = new QueryClient();

root.render(
   <Provider store={store}>
      <QueryClientProvider client={queryClient}>
         <ErrorBoundary>
            <App />
         </ErrorBoundary>
      </QueryClientProvider>
   </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
